import { useContext } from 'react';
import { invertedContext } from './context';

export const useInverted = () => {
  const inverted = useContext(invertedContext);
  return inverted;
};
